/**
 * One identity per person, everywhere.
 *
 * The board, the assign panel and the Timeline all show the same people, so a
 * name has to resolve to the same initials and the same colour in all three —
 * otherwise a proofer is red on one screen and teal on the next and the colour
 * stops carrying meaning. These were previously duplicated (and diverged: the
 * board hashed a hue, the assign panel picked from a fixed list), which is why
 * they live here now.
 *
 * There's no team directory behind assignee names on the board, so the colour
 * is derived from the name rather than stored.
 */

/** "Sarah Chen" → "SC"; a single word → its first two letters. */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/** A stable colour for a name. Fixed saturation/lightness so every avatar sits
 *  at the same weight and white text stays legible on all of them. */
export function avatarColor(name: string): string {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return `hsl(${h % 360} 52% 45%)`;
}
